var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"the-app-version"},[_c('span',{staticClass:"version"},[_vm._v(" V. "+_vm._s(_vm.APPLICATION_VERSION)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }